import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, showToast }) => {
    const { userId, user, loading } = useAuth();
    const navigate = useNavigate();
    const { username } = useParams();

    const currentUsername = user?.email
        ? user.email.split("@")[0]
        : null;

    useEffect(() => {
        if (!loading && !userId) {
            navigate("/");
            showToast("Please login to continue!", "warning");
            return;
        }

        // 🚫 block accessing other user's private routes
        if (
            !loading &&
            userId &&
            username &&
            currentUsername &&
            username !== currentUsername
        ) {
            navigate(`/${currentUsername}`);
            showToast("Unauthorized access", "error");
        }

    }, [userId, loading, username, currentUsername, navigate, showToast]);

    if (!userId) return null;
    if (username && username !== currentUsername) return null;

    return children;
};

export default PrivateRoute;